import { isPermissionPresent } from "../../../utilities/generalUtility";
import K from "../../../utilities/constants";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";
import {
  displayDollar,
  displayPercentage,
} from "../../../utilities/tableUtility";

const isEstimated = (data) =>
  data?.discountStatus === K.DiscountStatus.Estimated;

const discountPercentageTooltip = (data) => {
  if (isEstimated(data)) {
    return "Discount percent is assumed until hire fees are invoiced.";
  }

  return data?.discountInvoiceId
    ? `Discount calculated based on invoice ${data.discountInvoiceId}.`
    : null;
};

const discountTooltip = (data) =>
  isEstimated(data)
    ? "Discount amount is assumed until hire fees are invoiced."
    : null;

export const columns = (onEdit, roles) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Candidate Name",
    field: "candidateName",
    sortable: true,
    tooltipField: "candidateName",
  },
  {
    headerName: "Billing Type Name",
    field: "billingTypeName",
    sortable: true,
    tooltipField: "billingTypeName",
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
    tooltipField: "jobTitle",
  },
  {
    headerName: "Currency",
    field: "currency",
    sortable: true,
    tooltipField: "currency",
  },
  {
    headerName: "Billed Amount",
    field: "duplicateAmount",
    sortable: true,
    tooltipField: "duplicateAmount",
  },
  {
    headerName: "New Amount",
    field: "newAmount",
    sortable: false,
    valueGetter: (params) => displayDollar(params.data?.newAmount ?? 0),
  },
  {
    headerName: "Discount Percentage",
    field: "discountPercentage",
    sortable: false,
    valueGetter: (params) =>
      displayPercentage(params.data?.discountPercentage ?? 0),
    tooltipValueGetter: (params) => discountPercentageTooltip(params.data),
  },
  {
    headerName: "Discount",
    field: "discount",
    sortable: false,
    valueGetter: (params) => displayDollar(params.data?.discount ?? 0),
    tooltipValueGetter: (params) => discountTooltip(params.data),
  },
  {
    headerName: "Due Date",
    field: "dueDate",
    tooltipField: "dueDate",
    sortable: true,
    sort: "asc",
  },
  {
    headerName: "Commissionable?",
    field: "isCommissionable",
    sortable: true,
    tooltipField: "isCommissionable",
  },
  {
    headerName: "Active?",
    field: "isActive",
    sortable: true,
    tooltipField: "isActive",
  },
  {
    headerName: "Repeat",
    field: "isInfinite",
    sortable: true,
    minWidth: 200,
    tooltipField: "isInfinite",
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditScheduledBillings, roles),
    cellRenderer: (params) => (
      <>
        {isPermissionPresent(K.Permissions.EditScheduledBillings, roles) && (
          <EditIconButton onClick={() => onEdit(params.data)} />
        )}
      </>
    ),
  },
];
